import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { PrinterConnectionStatus } from 'app/models/printing.model';
import { Observable, catchError, distinctUntilChanged, map, of, switchMap, tap, timer } from 'rxjs';

interface PingConfig<T, R> {
  url: string;
  defaultValue: T;
  mapResponse: (response: R) => T;
  onStatusChange: (status: T) => void;
}

@Injectable()
export abstract class BasePingService {
  protected http = inject(HttpClient);

  /** 20 seconds */
  protected readonly PING_TIME_OFFLINE = 20 * 1000;
  /** 15 seconds */
  protected readonly PING_TIME_ONLINE = 15 * 1000;
  protected notAccessible: PrinterConnectionStatus = { isUp: false, devices: [] };

  protected createPingObservable<T, R>(config: PingConfig<T, R>): Observable<T> {
    let pingTime = this.PING_TIME_ONLINE;

    return timer(0, pingTime).pipe(
      switchMap(() =>
        this.http.get<R>(config.url).pipe(
          map(result => {
            const mappedResult = config.mapResponse(result);
            pingTime = this.PING_TIME_ONLINE;

            return mappedResult;
          }),
          catchError(() => {
            pingTime = this.PING_TIME_OFFLINE;

            return of(config.defaultValue);
          }),
        ),
      ),
      distinctUntilChanged(),
      tap(status => {
        config.onStatusChange(status);
      }),
    );
  }
}
